import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DatePicker, Modal } from 'antd';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from "react-redux";
import { fetchMenu } from '../../app/menu/menuSlice';
import { toast } from 'react-toastify';
import commonFunction from '../../Utils/commonFunction';
import { getWalletAmount } from '../../app/wallet/wallet.slice';
import WalletModal from './WalletModal';

function ChangeOrder() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userData, setUserData] = useState({
        pageSize: 1000,
        pageNumber: 1,
    });
    const [selectedMeal, setSelectedMeal] = useState(null);
    const [showmodal, setShowModal] = useState(false);
    const [remainingAmount, setRemainingAmount] = useState("");
    const [reasonType, setReasonType] = useState("");
    const [customReason, setCustomReason] = useState("");

    const menu = useSelector((state) => state.menu);

    const menuList = menu?.menu?.data?.menus || [];
    const userWalletAmount = useSelector((state) => state.wallet?.amount);

    // Load from location.state or fallback to localStorage
    const [orderItem, setOrderItem] = useState(() => {
        if (location.state?.orderItem) {
            return location.state.orderItem;
        } else {
            const stored = localStorage.getItem("changeOrderItem");
            return stored ? JSON.parse(stored) : null;
        }
    });

    const [childDetails, setChildDetails] = useState(() => {
        if (location.state?.childDetails) {
            return location.state.childDetails;
        } else {
            const stored = localStorage.getItem("childDetails");
            return stored ? JSON.parse(stored) : null;
        }
    });

    const [selectedPrice, setSelectedPrice] = useState(1);

    const childName = childDetails?.Child?.name || "";
    const REASONS = [
        { value: "Jeg har Ombestemt Mig", label: "Jeg har Ombestemt Mig" },
        { value: `${childName} er syg`, label: `${childName} er syg` },
        { value: `${childName} på Klassetur`, label: `${childName} på Klassetur` },
        { value: "other", label: "Andet" },
    ];

    useEffect(() => {
        if (!orderItem) {
            navigate('/');
            return;
        }

        const [day, month, year] = orderItem.deliveryDate.split('/');
        const deliveryDateAt6AM = new Date(year, month - 1, day, 6, 0, 0);
        const now = new Date();

        if (now > deliveryDateAt6AM) {
            alert("Updates allowed only before 6:00 AM of the delivery date.");
            navigate("/myprofile", {
                state: {
                    isOrder: true,
                },
            });
        }

        // set initial price
        const itemId = orderItem.OrdersItems[0]?.Menu?.menuId;

        const selectedItem = menuList.find((item) => item.idMenu === itemId);

        if (selectedItem) {
            setSelectedPrice(selectedItem.price);
            setSelectedMeal(selectedItem);
        }
    }, [orderItem, menuList]);

    const initialValues = {
        itemName: orderItem?.OrdersItems[0]?.itemName || '',
        quantity: orderItem?.OrdersItems[0]?.quantity || 1,
        deliveryDate: dayjs(orderItem?.deliveryDate, 'DD/MM/YYYY'),
    };

    const validationSchema = Yup.object({
        itemName: Yup.string().required('Item is required'),
        quantity: Yup.number().required('Quantity is required').min(1),
        deliveryDate: Yup.date().required('Delivery date is required'),
    });

    const handleSubmit = async (values) => {

        // Validate that reason is selected / provided
        const selectedReason = reasonType === 'other' ? customReason.trim() : (REASONS.find(r => r.value === reasonType)?.label || "");
        if (!selectedReason) {
            toast.error('Vælg venligst eller indtast en grund for ændringen.');
            return;
        }

        Modal.confirm({
            title: 'ændringsordre',
            content: `Er du sikker på du vil ændre denne til "${orderItem?.OrdersItems[0]?.itemName}" med "${values?.itemName}"?`,
            okText: 'Ja Ændre',
            cancelText: 'Nej',
            async onOk() {
                const dateObj = values.deliveryDate.toDate();
                const deliveryDateFormatted = `${dateObj.getDate().toString().padStart(2, '0')}/${(dateObj.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')}/${dateObj.getFullYear()}`;

                const payload = {
                    childId: orderItem.childId,
                    deliveryDate: deliveryDateFormatted,
                    totalPrice: selectedPrice * values.quantity,
                    orderItems: [
                        {
                            menuId: selectedMeal?.idMenu,
                            itemName: values.itemName,
                            description: selectedMeal?.description,
                            price: selectedPrice,
                            quantity: values.quantity,
                        },
                    ],
                    updateMessage: selectedReason,
                };

                const response = await commonFunction.updateOrder(payload, orderItem?.id);

                if (response.status == true) {
                    toast.success("Bestilling er Gennemført");
                    dispatch(getWalletAmount());
                    navigate("/myprofile", {
                        state: {
                            isOrder: true,
                        },
                    });
                    localStorage.clear(); // clear all the local storage after order success
                } else {
                    toast.error(response?.data?.message || "Failed to place order");
                }
            },
            onCancel() {
                console.log("Order change aborted.");
            },
        });
    };

    useEffect(() => {
        dispatch(fetchMenu(userData));

    }, [userData, dispatch]);

    const handleInsertMoney = (totalPrice) => {
        setRemainingAmount(parseInt(totalPrice - userWalletAmount.wallet));

        const maxWalletCap = 1000;
        if (userWalletAmount.wallet >= maxWalletCap) {
            toast.error("Wallet amount cannot exceed 1000 Kr.");
        } else {
            setShowModal(true);
        }
    };

    return (
        <>
            <main>
                <section className="page-info-sec">
                    <div
                        className="bg-fixed wow fadeIn"
                        data-wow-delay="0.1s"
                        style={{ background: 'url("assets/img/page-info1.png")' }}
                    />
                    <div
                        className="bg-fixed img-overlay wow fadeIn"
                        data-wow-delay="0.2s"
                    />
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-md-12">
                                <div
                                    className="page-info-block wow fadeInUp"
                                    data-wow-delay="0.3s"
                                >
                                    <h1>Ændre Ordre</h1>
                                    <div className="btm-line-2 text-center justify-content-center">
                                        <span />
                                        <span />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="sec-pd rel-z-1">
                    <div className="top-bottom-shaps">
                        <span className="shap shap-1" />
                        <span className="shap shap-2" />
                    </div>
                    <div className="container">
                        <div className="title-1 title-center wow fadeInUp" data-wow-delay="0.2s">
                            <h1>Ændre Ordre for "{childDetails?.Child?.name}"</h1>
                            {/* <div className="btm-line-1 text-center justify-content-center">
                                <span />
                                <span />
                            </div> */}
                        </div>
                        <div className="container mt-5">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ setFieldValue, values }) => (
                                    <Form>
                                        <div className="card p-4 shadow-sm" style={{ maxWidth: "85%", margin: "0 auto" }}>


                                            <div className="form-group mb-3">
                                                <label>Produkt Navn - Vælg Produkt du vil ændre til</label>
                                                <Field
                                                    as="select"
                                                    name="itemName"
                                                    className="form-control form-select-sm custom-select bg-white"
                                                    onChange={(e) => {
                                                        const selected = menuList.find((item) => item.title === e.target.value);
                                                        setSelectedPrice(selected?.price || 0);
                                                        setFieldValue('itemName', e.target.value);
                                                        setSelectedMeal(selected);
                                                    }}
                                                >
                                                    <option value="">-- Select Menu Item --</option>
                                                    {menuList.map((item) => (
                                                        <option key={item.idMenu} value={item.title}>
                                                            {item.title} - {item.price} Kr
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ErrorMessage name="itemName" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Antal</label>
                                                <Field
                                                    name="quantity"
                                                    type="number"
                                                    className="form-control"
                                                    min="1"
                                                    onChange={(e) => setFieldValue('quantity', parseInt(e.target.value))}
                                                />
                                                <ErrorMessage name="quantity" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label style={{ marginRight: '15px' }}>Leverings Dato</label>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    value={values.deliveryDate}
                                                    onChange={(date) => setFieldValue('deliveryDate', date)}
                                                />
                                                <ErrorMessage name="deliveryDate" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Total Pris</label>
                                                <input
                                                    className="form-control"
                                                    style={{ backgroundColor: '#e1dcdc', borderColor: '#ced4da' }}
                                                    value={`${selectedPrice * values?.quantity || 0} Kr`}
                                                    readOnly
                                                />
                                            </div>

                                            {/* Reason for change - required */}
                                            <div className="form-group mb-3">
                                                <label>Reason for change</label>
                                                <select
                                                    className="form-control"
                                                    value={reasonType}
                                                    onChange={(e) => setReasonType(e.target.value)}
                                                >
                                                    <option value="">-- Select Reason --</option>
                                                    {REASONS.map((r) => (
                                                        <option key={r.value} value={r.value}>{r.label}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {reasonType === 'other' && (
                                                <div className="form-group mb-3">
                                                    <label>Other — please describe</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        value={customReason}
                                                        onChange={(e) => setCustomReason(e.target.value)}
                                                        placeholder="Describe the reason for change"
                                                    />
                                                </div>
                                            )}

                                            {selectedPrice * values.quantity > userWalletAmount.wallet ? (
                                                <>
                                                    <span style={{ color: "red", fontWeight: "400", textAlign: "center" }}>
                                                        {/* You don't have enough money. You need {addAmount} Kr more. */}
                                                        Du har ikke nok venligst Indsæt Penge
                                                    </span>
                                                    <button type="button" className="btn btn-primary mt-2"
                                                        style={{ maxWidth: "85%", margin: "0 auto" }}
                                                        onClick={() => {
                                                            handleInsertMoney(selectedPrice * values.quantity);
                                                        }}
                                                    >
                                                        Indbetal
                                                    </button>
                                                </>
                                            ) : (
                                                <button type="submit" className="btn btn-primary mt-2" style={{ maxWidth: "85%", margin: "0 auto" }}>
                                                    Bekræft Ændring
                                                </button>
                                            )}
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </section>
                <WalletModal
                    handleOpen={showmodal}
                    handleClose={() => setShowModal(false)}
                    addMoreAmount={remainingAmount}
                />
            </main>
        </>
    );
}

export default ChangeOrder;